import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewPlan_de_Cuenta = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'plan_de_cuenta',
        name: 'Plan de Cuenta',
        component: ViewPlan_de_Cuenta,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
